export default __webpack_public_path__ + "static/media/logo-company-12.c7e569be.png";